function toCamelCase(str: string): string {
  return str.replace(/([-_][a-z])/gi, (match) => {
    // Переводим первую букву после символа '-' или '_' в верхний регистр
    return match[1].toUpperCase()
  })
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isObject(item: any): item is Record<string, any> {
  return typeof item === 'object' && !Array.isArray(item) && item !== null
}

/**  Функция рекурсивно преобразует ключи объекта в camelCase */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function convertKeysToCamelCase(obj: any): any {
  if (isObject(obj)) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const newObject: any = {}

    for (const key in obj) {
      if (key in obj) {
        const camelCaseKey: string = toCamelCase(key)
        newObject[camelCaseKey] = convertKeysToCamelCase(obj[key])
      }
    }

    return newObject
  } else if (Array.isArray(obj)) {
    return obj.map(convertKeysToCamelCase)
  }

  return obj
}
